
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.868 14.943c-.312-1.044-1.187-1.762-2.186-1.958l-10.56-1.5-4.685-9.919C21.999.587 21.062 0 20 0c-1.062 0-2 .587-2.437 1.566l-4.686 9.919-10.559 1.63c-1.062.131-1.874.914-2.186 1.958a3.012 3.012 0 00.687 2.937l7.622 7.765L6.63 36.737c-.125.849.063 1.697.625 2.284.5.653 1.25.979 2.062.979.375 0 .75-.13 1.062-.261l.125-.065c-.062-.98-.312-8.614 2.124-11.615 1.625-2.023 4-2.937 7.31-2.937 3.187 0 5.624 1.044 7.248 2.937 2.374 2.806 2.124 10.049 2.062 11.419l.187.065c.375.196.813.327 1.25.327.812 0 1.562-.392 2.062-.98.5-.652.75-1.5.625-2.283l-1.812-10.963 7.622-7.765c.75-.718 1-1.827.688-2.936zm-15.37 4.96c-.874 1.76-2.624 3-4.685 3a5.104 5.104 0 01-4.436-2.61c-.5-.848-.75-1.826-.75-2.87 0-3.002 2.312-5.482 5.248-5.482 2.874 0 5.248 2.415 5.248 5.481 0 .914-.25 1.762-.625 2.48z"}})])
          )
        }
      }
    